/**
 * Every image in `src/assets/design-gallery` matching the extension list is shown
 * in the design gallery (sorted by filename). Add or remove files there and rebuild.
 */
function importAll(r) {
  return r.keys().map((key) => {
    const src = r(key);
    const base = key
      .replace(/^\.\//, '')
      .replace(/\.[^.]+$/i, '')
      .replace(/[-_]+/g, ' ')
      .trim();
    return { src, alt: base || 'Design work' };
  });
}

const galleryContext = require.context(
  '../assets/design-gallery',
  false,
  /\.(png|jpe?g|gif|webp|svg)$/i
);

export const designGalleryImages = importAll(galleryContext).sort((a, b) =>
  a.alt.localeCompare(b.alt, undefined, { sensitivity: 'base' })
);
